import { useEffect, useState } from "react"
import { getFormatFecha } from "../../helpers/dates"
import PageController from "../pageController/PageController"
import './tbStyles.css'

export const TbArtists = ({ artists, updateArtist, deleteArtist }) => {

  const [artistas, setArtistas] = useState([])
  const [initData, setInitData] = useState(0)
  const pagesize = parseInt(process.env.REACT_APP_PAGE_RECORDS);

  useEffect(() => {
    const loadData = async () => {
      artists && setArtistas(await artists.slice(initData, initData + pagesize));
    }
    loadData()
  }, [artists, initData, pagesize]);

  return (
    <div className="table-container">
      <table cellSpacing='0'>
        <thead>
          <tr>
            <th>ID</th>
            <th>NOMBRE</th>
            <th>DECADA</th>
            <th className="responsive-movil">IMAGEN</th>
            <th className="responsive">VISIBLE</th>
            <th className="responsive">FECHOR</th>
            <th colSpan={2}>ACCIONES</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(artistas)
            ? artistas.map((artist) => (
              <tr key={artist.ART_CLAVE}>
                <td >{artist.ART_CLAVE}</td>
                <td>{artist.ART_NOMBRE}</td>
                <td>{artist.ART_DECADA}</td>
                <td className="responsive-movil">{artist.ART_IMAGE}</td>
                <td className="responsive"><input type='checkbox' checked={artist.ART_VISIBLE.data[0]} disabled /></td>
                <td className="responsive">{getFormatFecha(artist.ART_FECHOR)}</td>
                <td><button
                  onClick={() => updateArtist(artist)}
                  className="material-icons-outlined">edit</button></td>
                <td><button
                  onClick={() => deleteArtist(artist)}
                  className="material-icons-outlined">delete</button></td>

              </tr>
            ))
            : <h1>NO HAY DATOS EN LA TABLA</h1>
          }
        </tbody>
      </table>
      <section className="tbFooter">
        {
          artists &&
          <PageController initData={initData} setInitData={setInitData} length={artists.length} />
        }
          </section>
    </div>
  )
}
